import { createSlice } from '@reduxjs/toolkit';
import { INavBarState, NavBarState } from '../../../models';

/**
 * Initial Nav Bar state in store
 */
const initialState: INavBarState = {
  serviceDetails: {
    state: NavBarState.INCOMPLETE
  },
  serviceExceptions: {
    state: NavBarState.INCOMPLETE,
  },
  serviceOperations: {
    state: NavBarState.INCOMPLETE
  }
};

/* Nav Bar Reducer, which maintain the state of Side nav bar of create/view service */
const navBarSlice = createSlice({
  name: 'navBarSlice',
  initialState,
  reducers: {
    serviceDetailsIncomplete: (state) => {
      state.serviceDetails.state = NavBarState.INCOMPLETE;
    },
    serviceDetailsComplete: (state) => {
      state.serviceDetails.state = NavBarState.COMPLETE;
    },
    serviceDetailsIncorrect: (state) => {
      state.serviceDetails.state = NavBarState.INCORRECT;
    },
    serviceExceptionsIncomplete: (state) => {
      state.serviceExceptions.state = NavBarState.INCOMPLETE;
    },
    serviceExceptionsComplete: (state) => {
      state.serviceExceptions.state = NavBarState.COMPLETE;
    },
    serviceOperationsIncomplete: (state) => {
      state.serviceOperations.state = NavBarState.INCOMPLETE;
    },
    serviceOperationsComplete: (state) => {
      state.serviceOperations.state = NavBarState.COMPLETE;
    },
    serviceOperationsIncorrect: (state) => {
      state.serviceOperations.state = NavBarState.INCORRECT;
    },
    resetNavBarState: (state) => {
      state.serviceDetails = initialState.serviceDetails;
      state.serviceExceptions = initialState.serviceExceptions;
      state.serviceOperations = initialState.serviceOperations;
    }

  }
});
export const {
  serviceDetailsIncomplete,
  serviceDetailsComplete,
  serviceDetailsIncorrect,
  serviceExceptionsIncomplete,
  serviceExceptionsComplete,
  serviceOperationsIncomplete,
  serviceOperationsComplete,
  serviceOperationsIncorrect,
  resetNavBarState
} = navBarSlice.actions;
export default navBarSlice.reducer;
